const smartCollectionQueryKeys = {
  all: [
    "smart-collections"
  ],
  list: () => [
    ...smartCollectionQueryKeys.all,
    "list"
  ],
  item: (id) => [
    ...smartCollectionQueryKeys.all,
    id
  ]
};

export { smartCollectionQueryKeys };
//# sourceMappingURL=smartCollection.queryKeys.js.map
